// 세리사무소(税理士事務所) 전용 홈 — 기본 홈(Home.startview)과 나란히 놓고 TopNav 토글로 갈아끼운다.
//
// 이름이 zeirishi 인 이유: 税理士事務所(세무 대리 업무를 하는 사무소)이지 税務署(과세 관청)가 아니다.
// taxoffice 로 두면 영어권 개발자가 후자로 읽을 여지가 있어, 직업 자격을 가리키는 말을 그대로 쓴다.
//
// 기본 홈의 복사본이 아니다. 3,900줄짜리 AI 대화 화면을 두 벌로 두면 대화·첨부·세션을
// 고칠 때마다 두 번 고쳐야 하고, 안 고치면 두 포털이 조용히 갈라진다.
// 이 화면은 자기 것만 그린다 — 참조하는 상태도, 목업 데이터도 없다.
import React from 'react';

export default function HomeZeirishi() {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 32,
        fontWeight: 700,
        color: '#0F172A',
      }}
    >
      하이
    </div>
  );
}
